import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

@Injectable({
    providedIn: 'root',
})
export class ExportExcelService {
    constructor() { }

    exportExcel(excelData: { title: any; data: any; headers: any }) {
        //Title, Header & Data
        const title = excelData.title;
        const header = excelData.headers;
        const data = excelData.data;

        //Create a workbook with a worksheet
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet('Transcript');
        // worksheet.columns = [
        //     { header: 'S.no', key: 'id' },
        //     { header: 'Source In', key: 'startTime' },
        //     { header: 'Source Out', key: 'endTime' },
        //     { header: 'Source Duration', key: 'sourceDuration' },
        //     { header: 'Record In', key: 'recordIn' },
        //     { header: 'Record Out', key: 'recordOut' },
        // ]
        // worksheet.columns.forEach((column: any) => {
        //     column.width = column.header.length < 12 ? 12 : column.header.length
        // })
        //Adding Header Row
        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '4167B8' },
                bgColor: { argb: '' },
            };
            cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
            };
            cell.worksheet.getColumn(3).width = 25;
            // cell.worksheet.columns.forEach((column: any, i: any) => {
            //     // cell.worksheet.getColumn(i).width = 25;
            //     const lengths = column.values.map((v: any) => v.toString().length);
            //     const maxLength = Math.max(...lengths.filter((v: any) => typeof v === 'number'));
            //     column.width = maxLength;
            // });
        });

        // Adding Data with Conditional Formatting
        data.forEach((d: any, i: number) => {
            worksheet.addRow(Object.values(d));
            // worksheet.getColumn(i).width = 20;
        });

        worksheet.getColumn(5).width = 20;
        worksheet.addRow([]);

        //Generate & Save Excel File
        workbook.csv.writeBuffer().then((data) => {
            let blob = new Blob([ data ], {
                type: 'text/csv',
            });
            fs.saveAs(blob, title);
        });
    }
}